import { SxProps } from '@mui/material';
import { Theme } from '@mui/material/styles';

const baseTableNoResults = {
  minHeight: '25rem',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontStyle: 'italic',
  color: 'text.secondary',
  fontSize: '1.5rem',
};

const tableStyles: {
  tableNoResults: SxProps<Theme>;
  tableNoDataPlaceholderBox: SxProps<Theme>;
  tableNoDataPlaceholderText: SxProps<Theme>;
  chipIcon: SxProps<Theme>;
  buttonColumn: SxProps<Theme>;
} = {
  tableNoResults: baseTableNoResults,
  tableNoDataPlaceholderBox: {
    ...baseTableNoResults,
    minHeight: '7rem',
    backgroundColor: '#fff1f1',
  },
  tableNoDataPlaceholderText: {
    fontSize: '1.6rem',
    padding: '5px',
    textAlign: 'center',
  },
  chipIcon: {
    fontSize: 14,
    color: 'inherit',
  },
  buttonColumn: {
    width: '20%',
  },
};

export default tableStyles;
